import jwt_decode from 'jwt-decode';

const tokenKey = 'token';

export const getToken = (): string | null => window.localStorage?.getItem(tokenKey);

export const setToken = (value: string) => window.localStorage?.setItem(tokenKey, value);

export const removeToken = () => window.localStorage?.removeItem(tokenKey);

interface Decoded {
  payload: string;
}

export const getDataFromToken = (): Decoded | string => {
  try {
    const token = getToken();
    if (token) {
      const decoded = jwt_decode<Decoded>(token);
      return decoded.payload;
    }
    return '';
  } catch (e) {
    return '';
  }
};

interface DecodedToken {
  locRef?: string;
  rvcRef?: string;
  tbn?: Number;
}

export const decodeToken = (token: string): DecodedToken => {
  try {
    return jwt_decode<DecodedToken>(token);
  } catch (e) {
    return {};
  }
};
